module.exports = __webpack_public_path__ + "img/kr.92e545b1.png";